// WARNING: import needs to be statically analysable to not be problematic [at runtime]
import { lazy } from 'react';
import type { ComponentType, LazyExoticComponent } from 'react';
import type { Icon } from '@atlassian/forge-ui-types';

type LazyIcon = LazyExoticComponent<ComponentType<any>>;
export const IconPaths: Partial<Record<Icon, LazyIcon>> = {
	accessibility: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	activity: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	add: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'add-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'add-item': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	addon: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'ai-agent': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'ai-chat': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'ai-generative-text-summary': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	alert: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-image-center': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-image-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-image-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-text-center': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-text-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'align-text-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'angle-brackets': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	api: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	app: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'app-access': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'app-switcher': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'app-switcher-legacy': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	apps: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	archive: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'archive-box': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-down-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-down-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-down-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-left-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-right-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-up-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-up-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'arrow-up-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	assets: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'atlassian-intelligence': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	attachment: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	audio: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'audio-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	automation: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	backlog: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	basketball: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-branches': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-commits': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-pullrequests': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-repos': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-snippets': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bitbucket-source': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	board: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	boards: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	book: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'book-with-bookmark': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	border: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	branch: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	briefcase: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	bug: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'bullet-list': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	calendar: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'calendar-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'calendar-plus': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	camera: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'camera-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	capture: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	card: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	cash: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	changes: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-bar': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-bubble': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-matrix': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-pie': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-trend': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-trend-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chart-trend-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chat-widget': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	check: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'check-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'check-circle-outline': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'check-circle-unchecked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'check-mark': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	checkbox: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'checkbox-checked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'checkbox-indeterminate': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'checkbox-unchecked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-double-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-double-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-down-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-left-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-left-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-right-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-right-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'chevron-up-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'child-issues': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'child-work-items': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	clipboard: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	clock: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	close: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'cloud-arrow-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	code: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'collapse-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'collapse-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	comment: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'comment-add': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	commit: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	compass: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	component: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'content-width-narrow': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'content-width-wide': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'content-wrap-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'content-wrap-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	copy: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'credit-card': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	creditcard: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'creditcard-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	cross: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'cross-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'curly-brackets': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	customize: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	dashboard: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'data-flow': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'data-number': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'data-string': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	database: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	decision: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	defect: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	delete: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	department: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'detail-view': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'device-mobile': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	devices: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	discover: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'discover-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	discovery: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	document: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'document-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	documents: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	download: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'drag-handle-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'drag-handle-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'drag-handler': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	edit: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'edit-bulk': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'edit-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-add': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-center': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-image-center': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-image-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-image-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-align-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-attachment': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-background-color': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-bold': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-bullet-list': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-close': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-code': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-collapse': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-date': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-decision': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-divider': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-done': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-edit': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-emoji': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-error': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-expand': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-feedback': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-file': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-help': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-hint': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-horizontal-rule': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-image': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-image-resize': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-indent': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-info': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-italic': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-single': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-three-equal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-three-with-sidebars': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-two-equal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-two-left-sidebar': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-layout-two-right-sidebar': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-link': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-media-center': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-media-full-width': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-media-wide': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-media-wrap-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-media-wrap-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-mention': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-more': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-note': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-number-list': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-open': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-outdent': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-panel': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-photo': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-quote': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-recent': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-redo': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-remove': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-search': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-settings': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-success': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-table': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-task': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-text-style': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-undo': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-unlink': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'editor-warning': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	email: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	emoji: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-activity': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-add': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-casual': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-custom': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-emoji': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-flags': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-food': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-frequent': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-keyboard': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-nature': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-neutral': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-objects': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-people': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-productivity': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-remove': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-symbols': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'emoji-travel': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	epic: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	error: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'exclamation-square': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'expand-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'expand-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	export: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'eye-open': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'eye-open-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'eye-open-strikethrough': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	feed: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	feedback: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	field: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'field-alert': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'field-checkbox-group': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'field-dropdown': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'field-radio-group': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	file: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	files: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	filter: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	flag: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'flag-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	flask: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'focus-area': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	folder: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'folder-closed': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'folder-open': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	followers: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	form: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'fullscreen-enter': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'fullscreen-exit': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	glasses: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	globe: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	goal: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'graph-bar': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'graph-line': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	grid: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'grow-diagonal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'grow-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'grow-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	hashtag: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	headphones: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	heart: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	highlight: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-audio-only': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-chevron-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-chevron-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-dial-out': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-lobby': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-outgoing-sound': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'hipchat-sd-video': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	home: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'home-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	image: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'image-fullscreen': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'image-inline': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'image-resize': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'image-scaled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	inbox: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	incident: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	info: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	information: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'information-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'invite-team': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	issue: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'issue-raise': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	issues: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'jira-capture': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'jira-labs': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'jira-test-session': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'key-result': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	label: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-one-column': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-three-columns': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-three-columns-sidebars': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-two-columns': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-two-columns-sidebar-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'layout-two-columns-sidebar-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	library: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	lightbulb: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lightbulb-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	like: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	link: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'link-broken': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'link-external': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'link-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'list-bulleted': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'list-checklist': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'list-numbered': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lobby-bell': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	location: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	lock: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lock-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lock-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lock-locked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'lock-unlocked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'log-in': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'log-out': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'magic-wand': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	markdown: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	marketplace: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	maximize: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-actual-size': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-add-comment': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-audio': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-code': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-document': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-filter': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-fit-to-page': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-full-screen': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-grid': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-image': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-line': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-preselected': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-presentation': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-scale-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-scale-small': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-spreadsheet': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-video': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-zoom-in': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'media-services-zoom-out': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	megaphone: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	menu: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'menu-expand': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'merge-failure': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'merge-success': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	microphone: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	minimize: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	minus: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'minus-square': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	mobile: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	more: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'more-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	node: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	note: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	notification: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'notification-direct': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'notification-muted': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	objective: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'office-building': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'office-building-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'on-call': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	open: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	operations: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	overview: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	page: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'page-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	pages: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'paint-bucket': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'paint-palette': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'panel-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'panel-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	pen: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	people: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'people-group': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	person: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-add': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-added': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-avatar': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-offboard': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-remove': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-warning': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'person-with-tick': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	phone: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	pin: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'pin-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'plus-square': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'power-plug': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	preferences: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	premium: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'presenter-mode': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	printer: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-blocker': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-critical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-high': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-highest': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-low': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-lowest': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-major': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-medium': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-minor': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'priority-trivial': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	problem: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	project: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'project-status': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'projection-screen': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'pull-request': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	pulse: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	question: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'question-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	questions: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	queues: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'quotation-mark': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	quote: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	radio: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'radio-checked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'radio-unchecked': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	recent: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	redo: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	refresh: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	release: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	retry: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	roadmap: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'room-menu': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'rovo-chat': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	scales: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	schedule: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'schedule-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	scorecard: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	screen: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'screen-plus': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	search: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'select-clear': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	send: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	settings: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	shapes: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	share: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	shield: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'shield-strikethrough': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	ship: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	shortcut: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'show-more-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'show-more-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'shrink-diagonal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'shrink-horizontal': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'shrink-vertical': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sidebar-collapse': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sidebar-expand': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sign-in': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sign-out': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'smart-link': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'smart-link-card': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'smart-link-embed': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'smart-link-inline': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'smart-link-list': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	snippet: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sort-ascending': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'sort-descending': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	spreadsheet: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	sprint: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	star: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'star-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'star-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'star-starred': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'star-unstarred': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-discovery': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-error': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-information': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-success': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-verified': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'status-warning': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	stopwatch: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	story: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'stroke-weight-extra-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'stroke-weight-large': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'stroke-weight-medium': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'stroke-weight-small': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	subtask: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	subtasks: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	success: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	suitcase: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	support: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	switcher: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	table: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-cell-clear': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-cell-merge': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-cell-split': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-column-add-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-column-add-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-column-delete': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-column-move-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-column-move-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-columns-distribute': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-row-add-above': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-row-add-below': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-row-delete': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-row-move-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'table-row-move-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	tag: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'takeout-food': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	target: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	task: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'task-in-progress': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'task-to-do': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	tasks: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	teams: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	text: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-bold': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-heading': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-indent-left': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-indent-right': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-italic': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-shorten': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-spellcheck': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-strikethrough': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-style': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-underline': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'text-wrap': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	theme: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'thumbs-down': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'thumbs-up': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	timeline: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	tools: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	transition: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	translate: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	trash: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	tray: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	tree: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	undo: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	unlink: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	unlock: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'unlock-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'unlock-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	upload: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'user-avatar-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vehicle-car': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-audio-on': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-camera-on': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-full-screen-off': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-full-screen-on': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-pause': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-play': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-volume-full': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-volume-half': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'vid-volume-muted': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	video: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-circle': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-next': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-next-overlay': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-pause': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-pause-overlay': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-play': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-play-overlay': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-previous': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-previous-overlay': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-skip-backward-fifteen': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-skip-backward-ten': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-skip-forward-fifteen': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-skip-forward-ten': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-stop': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'video-stop-overlay': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'volume-high': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'volume-low': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'volume-muted': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	warning: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	watch: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'watch-filled': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	whiteboard: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'work-item': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'work-items': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	world: lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'world-small': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'zoom-in': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
	'zoom-out': lazy(
		() => import(/* webpackChunkName: "forge-ui-icons" */ '@atlaskit/icon/core/question-circle'),
	),
};
